import React, { useContext } from 'react';
import { useChatbot } from 'contexts/ChatbotContext';
import { UserContext, UserContextProps } from 'contexts/UserContext';
import { useTranslation } from 'react-i18next';
import 'components/chatbot/Chatbot.scss';
import LogoChatbot from 'assets/svg/logo-comcolors-chatbot.svg';

const ChatbotButton: React.FC = () => {
  const { t } = useTranslation('translation');
  const { isOpen, openChatbot } = useChatbot();
  const { user } = useContext(UserContext) as UserContextProps;

  // Only show chatbot if user is authenticated
  if (!user || isOpen) return null;

  return (
    <button className="chatbot-button" onClick={openChatbot} aria-label={t('chatbot.openchatbot')}>
      <img src={LogoChatbot} alt="ComColors Chatbot" className="chatbot-button-logo" />
    </button>
  );
};

export default ChatbotButton;
